<template>
  <div>
    <v-text-field
        outlined
        v-model="name"
        class="rounded-lg"
        label="Название"
        :rules="rulesMandatory"
        dense
    ></v-text-field>
    <v-textarea
        v-model="description"
        outlined
        class="rounded-lg"
        counter
        dense
        label="Описание">
    </v-textarea>
    <v-select
        v-model="kind"
        :items="kinds"
        :rules="rulesMandatory"
        outlined
        class="rounded-lg"
        counter
        dense
        label="Вид деятельности"
    />
    <v-text-field
        v-if="kind === 'kind_other'"
        v-model="kind_other"
        :rules="rulesMandatory"
        outlined
        class="rounded-lg"
        counter
        dense
        label="Вид деятельности (Иное)"
    />
    <v-text-field
        v-model="subgraph_order"
        :rules="rulesMandatory"
        outlined
        class="rounded-lg"
        counter
        dense
        label="Подпункт Порядка, утвержденного приказом Минобрнауки России от 27.12.2016 №1663, которому соответствует достижение в Мероприятии"
    />
    <v-select
        v-model="status_event"
        :items="statusEvents"
        :rules="rulesMandatory"
        outlined
        class="rounded-lg"
        dense
        label="Статус Мероприятия"
    />
    <v-text-field
        v-if="status_event === 'status_event_other'"
        v-model="status_event_other"
        :rules="rulesMandatory"
        outlined
        class="rounded-lg"
        counter
        dense
        label="Статус Мероприятия (иной)"
    />
    <v-select
        v-model="organization"
        :items="organizations"
        :rules="rulesMandatory"
        outlined
        class="rounded-lg"
        dense
        label="Организатор (-ы) Мероприятия"
    />
    <v-text-field
        v-if="organization === 'organization_other'"
        v-model="organization_other"
        :rules="rulesMandatory"
        outlined
        class="rounded-lg"
        counter
        dense
        label="Организатор (-ы) Мероприятия (иное)"
    />
    <v-text-field
        v-model="organization_name"
        :rules="rulesMandatory"
        outlined
        class="rounded-lg"
        counter
        dense
        label="Наименование(-я) организатора(-ов) Мероприятия"
    />
    <v-select
        v-model="category_importance"
        :items="categoryImportances"
        :rules="rulesMandatory"
        outlined
        class="rounded-lg"
        dense
        label="Категория важности (приоритетности) Мероприятия для образовательной организации"
    />
    <v-select
        v-model="participants_number"
        :items="participantsNumbers"
        :rules="rulesMandatory"
        outlined
        class="rounded-lg"
        dense
        label="Численность участников Мероприятия (при наличии информации)"
    />
    <v-text-field
        v-model="link_document"
        outlined
        class="rounded-lg"
        counter
        dense
        label="Ссылка на документ, определяющий порядок организации и проведения Мероприятия (при наличии)"
    />
    <v-text-field
        v-model="link_site"
        outlined
        class="rounded-lg"
        counter
        dense
        label="Ссылка на сайт Мероприятия, группу в социальных сетях, публикации в СМИ (при наличии)"
    />
  </div>
</template>

<script>

import AddCard from "../Cards/AddCard";
import {createHelpers} from "vuex-map-fields";
import axios from "axios";

const {mapFields} = createHelpers({
  getterType: 'achievement_kind/getPayloadAchievementKind',
  mutationType: 'achievement_kind/updatePayloadAchievementKind',
});

export default {
  name: "SectionEditAchievement",

  data() {
    return {
      rulesMandatory: [
        (v) => !!v || "Это поле обязательно к заполнению",
      ],
      metadata: {}
    }
  },

  async mounted() {
    const res = await axios.get("/portfolio/api/admin/metadata/prtf_achievement_enums")
    this.metadata = res.data
  },

  components: {
    AddCard,
  },

  computed: {
    ...mapFields([
      'name',
      'description',
      'kind',
      'kind_other',
      'subgraph_order',
      'status_event',
      'status_event_other',
      'organization',
      'organization_other',
      'organization_name',
      'category_importance',
      'participants_number',
      'link_document',
      'link_site',
    ]),

    kinds() {
      return this.convertToSelectItems(this.metadata.kinds) || []
    },

    statusEvents() {
      return this.convertToSelectItems(this.metadata.status_events) || []
    },

    organizations() {
      return this.convertToSelectItems(this.metadata.organizations) || []
    },

    categoryImportances() {
      return this.convertToSelectItems(this.metadata.category_importances) || []
    },

    participantsNumbers() {
      return this.convertToSelectItems(this.metadata.participants_numbers) || []
    },
  },

  methods: {
    convertToSelectItems(obj) {
      return Object.entries(obj || {}).map(([key, value]) => ({
        text: value,
        value: key
      }));
    },


  },
}
</script>

<style scoped>
</style>